import { authClient } from './lib/authClient';
import {
  Alert,
  Anchor,
  Button,
  Divider,
  Paper,
  PasswordInput,
  Space,
  TextInput,
  Title,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { BadgeCheck, BadgeX } from 'lucide-react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useLocation } from 'wouter';

export const Signin = () => {
  const [uiError, setUiError] = useState<null | string>(null);
  const [, navigate] = useLocation();
  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
  } = useForm<{
    email: string;
    password: string;
  }>();

  const submitHandler = handleSubmit(async (formData) => {
    const { error } = await authClient.signIn.email({
      email: formData.email,
      password: formData.password,
    });

    // console.error(error);

    if (error) {
      setUiError(error.message || 'An error occurred, please try again');
    } else {
      notifications.show({
        message: (
          <>
            <BadgeCheck stroke="var(--color-lime-400)" /> Sign in successful!
          </>
        ),
      });
      navigate('/', { replace: true });
    }
  });

  return (
    <Paper
      className="w-1/2 mx-auto mt-20"
      p="xl"
      radius="md"
      shadow="md"
      withBorder
    >
      <Title order={3}>Sign in</Title>
      <Space h="sm" />
      <Divider />
      <Space h="sm" />
      {uiError && (
        <>
          <Alert
            color="red"
            icon={<BadgeX />}
            title=""
            variant="filled"
          >
            {uiError.toString()}
          </Alert>
          <Space h="sm" />
        </>
      )}
      <form
        noValidate
        onSubmit={submitHandler}
      >
        <TextInput
          error={errors?.email?.message?.toString()}
          label="Email address"
          required
          type="email"
          {...register('email', {
            required: 'Please provide an email address',
          })}
        />
        <Space h="md" />
        <PasswordInput
          error={errors?.password?.message?.toString()}
          label="Password"
          required
          {...register('password', {
            required: 'Please provide a password',
          })}
        />
        <Space h="xl" />
        <Button
          disabled={isSubmitting}
          loading={isSubmitting}
          type="submit"
        >
          Sign in
        </Button>
      </form>
      <Space h="xl" />
      <Anchor
        component={Link}
        to="/signup"
      >
        Sign up
      </Anchor>
    </Paper>
  );
};
